interface SkeletonCardProps {
  variant?: "listing" | "wide" | "stats" | "block";
  className?: string;
}

export function SkeletonCard({ variant = "listing", className = "" }: SkeletonCardProps) {
  const base = "rounded-xl bg-surface-container-highest animate-shimmer";

  switch (variant) {
    case "wide":
      return (
        <div className={`col-span-2 ${className}`}>
          <div className={`aspect-[16/9] ${base}`} />
        </div>
      );
    case "stats":
      return <div className={`h-24 ${base} ${className}`} />;
    case "block":
      return <div className={`h-32 ${base} ${className}`} />;
    default:
      return <div className={`aspect-[4/5] ${base} ${className}`} />;
  }
}
